<i class="fa-solid fa-spinner-third fa-spin-pulse"></i>
{{ text }}
